export default "__VITE_ASSET__be9342b5__"